import React from 'react';
import { Layout, Card, Typography, Row, Col, Divider } from 'antd';
import { CompassOutlined, UserOutlined, AppstoreAddOutlined, LineChartOutlined, BorderInnerOutlined, CheckCircleOutlined } from '@ant-design/icons';
import './BuyerService.css'; // Reusing the seller CSS for consistency

const { Content } = Layout;
const { Title, Paragraph, Text } = Typography;

const BuyerService = () => {
  const services = [
    {
      icon: <UserOutlined style={{ fontSize: '24px', color: '#AA5970' }} />,
      title: "1. Consultation: Clarifying Your Goals & Criteria",
      content:
        "We start by understanding why you're buying and what you're looking for—be it own stay, rental yield, legacy planning, or capital appreciation. I’ll help define your key criteria (location, layout, budget, timeline) to ensure our search is sharply focused.\n\n💡 P.S. I do not charge any commission if you’re purchasing a private property."
    },
    {
      icon: <AppstoreAddOutlined style={{ fontSize: '24px', color: '#AA5970' }} />,
      title: "2. Tailored Recommendations: The Right Developments for You",
      content:
        "Based on your needs, I’ll shortlist developments with real growth potential, good entry points, and alignment with your goals. I don’t just recommend what’s trending—I recommend what’s strategically sound."
    },
    {
      icon: <LineChartOutlined style={{ fontSize: '24px', color: '#AA5970' }} />,
      title: "3. Macro Analysis: Reading the Development in Context",
      content:
        "You’ll get data-driven insights on the project: its historical trends, supply risks, and URA masterplan impact. This ensures we only enter projects with strong fundamentals and future-proof demand."
    },
    {
      icon: <BorderInnerOutlined style={{ fontSize: '24px', color: '#AA5970' }} />,
      title: "4. Micro Analysis: Picking the Right Stack, Facing & Layout",
      content:
        "Not all units are equal. I’ll break down undervalued stacks, renter/family-friendly layouts, and high-exit facings. These micro-level decisions can make six-figure differences—and I help you get it right from Day 1."
    },
    {
      icon: <CheckCircleOutlined style={{ fontSize: '24px', color: '#AA5970' }} />,
      title: "5. Viewings, Negotiation & Closing",
      content:
        "From viewings to final deal—I manage everything end-to-end. My sharp negotiation and market pulse help you buy at the right price in any condition."
    }
  ];

  return (
    <Content className = "top-color" style={{ padding: '24px', maxWidth: '1200px', margin: '0 auto'  }}>
      <div className="top-color"> 
      <Title level={1} style={{ textAlign: 'center', marginBottom: '24px', color: '#AA5970' }}>
        🧭 Buyer’s Kit: Purchase with Clarity, Confidence & Direction
      </Title>

      <Paragraph style={{
        fontSize: '1.1rem',
        textAlign: 'center',
        maxWidth: '800px',
        margin: '0 auto 40px'
        
      }}>
        Whether you’re a first-time buyer, upgrader, or savvy investor—buying right matters more than ever in today’s market.
        I go beyond opening doors—I help you spot opportunities, assess risk, and enter at a safe PSF for long-term value.
      </Paragraph>

      <Divider orientation="left">
        <Text strong style={{ color: '#AA5970', fontSize: '1.2rem' }}>
          Here's how I help you buy with strategy, not emotion:
        </Text>
      </Divider>
</div>
      <Row gutter={[24, 24]} style={{ marginTop: '40px' }}>
  {services.map((service, index) => {
    const isFourth = index === 3;
    return (
      <Col
  key={index}
  xs={24}
  sm={12}
  md={{ span: 8, offset: isFourth ? 3 : 0 }}
>
        <Card className={`buyer-seller-service-card color-strip-${(index % 5) + 1}`}
          hoverable
          style={{
            height: '100%',
            borderColor: '#DDD7D7',
            borderRadius: '8px'
          }}
          bodyStyle={{ padding: '24px' }}
        >
          <div style={{
            display: 'flex',
            alignItems: 'center',
            marginBottom: '16px'
          }}>
            {service.icon}
            <Title level={4} style={{
              margin: '0 0 0 12px',
              color: '#050000', whiteSpace: 'pre-line',fontFamily:'ivypresto'
            }}>
              {service.title}
            </Title>
          </div>
          <Paragraph style={{ color: '#050000', whiteSpace: 'pre-line',fontFamily:'ivypresto'}}>
            {service.content}
          </Paragraph>
        </Card>
      </Col>
    );
  })}
</Row>

    </Content>
  );
};

export default BuyerService;
